import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  makeStyles,
  useTheme,
  AppBar,
  Tabs,
  Tab,
  DialogContentText,
  TextField,
  FormHelperText,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import SwipeableViews from "react-swipeable-views";
import PaypalCheckoutButton from "../PaypalCheckoutButton";
import { useForm } from "react-hook-form";
import Cards from "react-credit-cards";
// import OpenPay from "openpay";
import { API_URL } from "../../constants/constants";

import { useAuth0 } from "../../hooks/react-auth0-spa";
import "react-credit-cards/es/styles-compiled.css";
import axios from "axios";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils_cards";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
    alignContent: "center",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
const TabsSaldo = () => {
  const { user, getTokenSilently } = useAuth0();
  const [cargando, setCargando] = useState(false);
  useEffect(() => {
    const OpenPayWindow = window.OpenPay;
    OpenPayWindow.setId("mey5dn9izx6neyiabqml");
    OpenPayWindow.setApiKey("pk_456ba1140a284857b69be1852bd0f837");
    OpenPayWindow.setSandboxMode(false);
    // console.log(OpenPayWindow.getSandboxMode());
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css";
    link.integrity =
      "sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk";
    link.crossOrigin = "anonymus";
    link.id = "bootstrap_cards";
    document.body.appendChild(link);
    return function () {
      document.getElementById("bootstrap_cards").remove();
    };
  }, []);
  const por = 0.0495;
  const { register, errors } = useForm();
  const [recarga, setRecarga] = useState(1000.0);
  const [recIVA, setRecIVA] = useState(recarga + recarga * por + 4);
  const classes = useStyles();
  const theme = useTheme();
  // console.log(recarga)
  const order = {
    customer: "",
    total: recIVA,
    items: [
      {
        sku: "001",
        name: "Recarga DrEnvio",
        price: recIVA,
        quantity: 1,
        currency: "MXN",
      },
    ],
  };
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const handleRecargas = (e) => {
    setRecarga(+e);
    setRecIVA(Math.round((+e + +e * por + 4) * 100) / 100);
    // console.log(recarga)
    // console.log(recIVA)
  };
  /**Metodos tarjeta de credito */
  const [tarjeta, setTarjeta] = useState({
    number: "",
    name: "",
    expiry: "",
    cvc: "",
    issuer: "",
    focused: "",
    formData: null,
  });
  const handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      setTarjeta({ ...tarjeta, issuer });
    }
  };

  const handleInputFocus = ({ target }) => {
    // console.log(target.name);
    setTarjeta({
      ...tarjeta,
      focused: target.name,
    });
  };

  const handleInputChange = ({ target }) => {
    if (target.name === "number") {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    }

    setTarjeta({ ...tarjeta, [target.name]: target.value });
  };
  let form;
  const handleSubmit = (e) => {
    setCargando(true);
    e.preventDefault();
    // const { issuer } = tarjeta;
    const formData = [...e.target.elements]
      .filter((d) => d.name)
      .reduce((acc, d) => {
        acc[d.name] = d.value;
        return acc;
      }, {});

    setTarjeta({ ...tarjeta, formData });
    const OpenPayWindow = window.OpenPay;
    const expirationDate = formData.expiry.split("/");
    formData.number = formData.number.replace(/\s+/g, "");
    const ObjectToken = {
      card_number: formData.number.trim(),
      holder_name: formData.name.trim(),
      expiration_month: expirationDate[0],
      expiration_year: expirationDate[1],
      cvv2: formData.cvc,
    };
    /**Este es el session ID */
    const device_session_id = window.OpenPay.deviceData.setup("open_pay");
    OpenPayWindow.token.create(
      { ...ObjectToken },
      async (success) => {
        const source_id = success.data.id;
        try {
          const t = await getTokenSilently();
          await axios.post(
            API_URL + `/openpay/${user.sub}`,
            { device_session_id, source_id, recarga: formData.recarga },
            {
              headers: {
                Authorization: `Bearer ${t}`,
                // "Access-Control-Allow-Origin": "*"
              },
            }
          );
          alert(`El Pago fue procesado correctamente, recargue la pagina `);
        } catch (e) {
          alert("El Pago no se ha realizado, vuelva a intentarlo ");
        }
        setCargando(false);
      },
      (error) => {
        alert("Verifique los datos de su tarjeta");
        setCargando(false);
      }
    );
  };
  /**Fin metodos de tarjeta */
  return (
    <div className={classes.root}>
      <Backdrop open={cargando} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Deposito" {...a11yProps(0)} />
          <Tab label="Paypal" {...a11yProps(1)} />
          <Tab label="Tarjeta" {...a11yProps(2)} style={{ display: "none" }}/>
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {/**Aqui va toda la informacion del deposito a cuenta */}

          <DialogContentText>
            <p>
              <strong>
                Envia tu comprobante de Transferencia/Deposito a nuestro chat en linea.
              </strong>
            </p>
          </DialogContentText>
          <DialogContentText id="alert-dialog-slide-description">
            <h3>Datos Bancarios:</h3>
            <hr />

            <div className={classes.datosBancarios}>
              <p>Dr Envio SA de CV </p>
              <p>Banco: Banamex</p>
              <p>Número de cuenta: 8517401</p>
              <p>Clave Interbancaria: 00 2580 7013 8517 4012</p>
            </div>
            <hr />
          </DialogContentText>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          {/**Aqui va toda la informacion de Paypal  */}
          <DialogContentText style={{ textAlign: "center" }}>
            <p>
              Recuerda que al pagar con tu cuenta de PayPal se te cobrará una
              comisión de servicio la cual se calculará antes de realizar tu
              pago.
            </p>

            <div style={{ backgroundColor: "#f5f5f5" }}>
              <p>Comisión por Servicio:</p>
              <p>
                <strong>4.95% + $4.00MXN </strong>
              </p>
              <p>Más IVA</p>
            </div>
            <p>
              <strong>Selecciona el monto que desea recargar.</strong>
            </p>

            <TextField
              autoComplete="off"
              type="number"
              error={!!errors.numero}
              inputRef={register({
                required: true,
              })}
              label="cantidad"
              name="numero"
              variant="outlined"
              value={recarga}
              size="small"
              onChange={(e) =>
                e ? handleRecargas(e.target.value) : handleRecargas(0)
              }
            />
            {recarga < 0 && (
              <FormHelperText error>
                No puedes realizar esta recarga
              </FormHelperText>
            )}
            <p>Cantidad a cobrar:{recIVA}</p>
          </DialogContentText>
          <PaypalCheckoutButton recarga={recarga} order={order} />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <div style={{ marginTop: 10 }}>
            <Cards
              cvc={tarjeta.cvc}
              expiry={tarjeta.expiry}
              focused={tarjeta.focused}
              name={tarjeta.name}
              number={tarjeta.number}
              callback={handleCallback}
            />

            <form
              id="open_pay"
              style={{ marginTop: 10 }}
              ref={(c) => (form = c)}
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label> Cantidad a Recargar </label>
                <input
                  type="number"
                  // type="tel"
                  step="0.01"
                  min={1}
                  name="recarga"
                  className="form-control"
                  placeholder="$20"
                  required
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="number"
                  className="form-control"
                  placeholder="Numero de la tarjeta"
                  pattern="[\d| ]{16,22}"
                  required
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Nombre"
                  required
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                />
              </div>
              <div className="row">
                <div className="col-6">
                  <input
                    type="tel"
                    name="expiry"
                    className="form-control"
                    placeholder="Valida hasta"
                    pattern="\d\d/\d\d"
                    required
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                  />
                </div>
                <div className="col-6">
                  <input
                    type="tel"
                    name="cvc"
                    className="form-control"
                    placeholder="CVC"
                    pattern="\d{3,4}"
                    required
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                  />
                </div>
              </div>
              <input type="hidden" name="issuer" value={tarjeta.issuer} />
              <div className="form-actions" style={{ marginTop: 10 }}>
                <button className="btn btn-primary btn-block">Recargar</button>
              </div>
            </form>
          </div>
        </TabPanel>
      </SwipeableViews>
    </div>
  );
};

export default TabsSaldo;
